import { render, staticRenderFns } from "./foodindicatordetails.vue?vue&type=template&id=004c3d30&scoped=true&"
import script from "./foodindicatordetails.vue?vue&type=script&lang=js&"
export * from "./foodindicatordetails.vue?vue&type=script&lang=js&"
import style0 from "./foodindicatordetails.vue?vue&type=style&index=0&id=004c3d30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004c3d30",
  null
  
)

export default component.exports